export default {
  hydra: 'https://api-usgov.webex.com/v1',
  u2c: 'https://u2c.gov.ciscospark.com/u2c/api/v1',
  sqdiscovery: 'https://ds.ciscospark.com/v1/region', // TODO: fedramp load balanced URL? this has been here for years as of now but now explicitly done
};
